import { Link } from "react-router-dom";
import { ShopAdminGate } from "../components/ShopAdminGate";
import { HeldDucksPanel } from "../components/HeldDucksPanel";
import { adminBase } from "../lib/adminBase";

export default function ShopAdminHeld() {
  return (
    <ShopAdminGate>
      <div className="min-h-screen bg-dots">
        <main className="max-w-6xl mx-auto px-4 sm:px-8 py-8 sm:py-10 space-y-6">
          <nav className="flex flex-wrap gap-4 text-sm font-semibold text-accent">
            <Link to={`${adminBase()}/orders`} data-testid="held-to-orders" className="hover:underline">Orders</Link>
            <Link to={`${adminBase()}/queue`} data-testid="held-to-queue" className="hover:underline">Queue</Link>
            <Link to={`${adminBase()}/spend-gate`} data-testid="held-to-spend-gate" className="hover:underline">Spend gate</Link>
          </nav>
          <header>
            <span className="text-xs font-mono2 uppercase tracking-widest text-accent font-semibold">View check</span>
            <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Held ducks</h1>
            <p className="text-muted-foreground text-sm md:text-base mt-2 max-w-2xl">
              Ducks the view check will not let into the sculpt: an upload that is not a 3D-style render, several ducks, a sheet or a scene. Look at the image, then let it through with a reason or leave it held.
            </p>
          </header>
          <HeldDucksPanel />
        </main>
      </div>
    </ShopAdminGate>
  );
}
